const getStateLink = (basePath, productTypeFilter, state) => {
  const tail = state || ''
  const body =
    productTypeFilter && productTypeFilter.value
      ? productTypeFilter.value
      : 'all'
  return `${basePath}/${body}/${tail}`
}

const getAssetTypeLink = (basePath, assetType, stateFilter) => {
  const tail = stateFilter && stateFilter.value ? `${stateFilter.value}` : ''
  const body = `${assetType || 'all'}`
  return `${basePath}/${body}/${tail}`
}

export { getStateLink, getAssetTypeLink }
